import { render, staticRenderFns } from "./SchoolEdit.vue?vue&type=template&id=31434196&scoped=true&"
import script from "./SchoolEdit.vue?vue&type=script&lang=js&"
export * from "./SchoolEdit.vue?vue&type=script&lang=js&"
import style0 from "./SchoolEdit.vue?vue&type=style&index=0&id=31434196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31434196",
  null
  
)

export default component.exports